<template>
  <div id="contents">
    <div id="exCancle" class="container">
      <h3 class="stitle mb10">예약취소</h3>
      <h4 class="stitle2 mb10 tleft">체험관 예약취소 확인</h4>
      <div class="tb_wrap mb30 res_tbl_grid_wrap">
        <table class="tb_basic">
          <caption>예약정보</caption>
          <tbody>
            <tr>
              <th class="tbg cw120">예약번호</th>
              <td class="tleft">{{ bundleRvNo }}</td>
              <th class="tbg cw120">예약상태</th>
              <td class="tleft">{{ reserveInfo.rvSitu }}</td>
            </tr>
            <tr>
              <th class="tbg cw120">예약일</th>
              <td class="tleft">{{ reserveInfo.rvDtm }}</td>
              <th class="tbg cw120">예약자명</th>
              <td class="tleft">{{ reserveInfo.userName }}</td>
            </tr>
            <tr>
              <th class="tbg cw120">휴대폰</th>
              <td class="tleft">{{ reserveInfo.userMobileNum }}</td>
              <th class="tbg cw120">이메일</th>
              <td class="tleft">{{ reserveInfo.userEmail }}</td>
            </tr>
            <tr v-if="reserveInfo.hpOrgInfoId > 0">
              <th class="tbg cw120">단체명</th>
              <td class="tleft">{{ reserveInfo.orgName }}</td>
              <th class="tbg cw120">학년</th>
              <td class="tleft">{{ reserveInfo.gradeNm }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="tb_wrap">
        <table class="tb_basic">
          <caption>상품 예약 목록</caption>
          <colgroup>
            <col width="9.5%" />
            <col />
            <col />
            <col />
            <col />
            <col width="120" />
            <col width="120" />
            <!-- <col width="120" /> -->
          </colgroup>
          <thead>
            <tr class="tbg">
              <th scope="col">
                <span class="checkbox">
                  <input type="checkbox" id="checkTotal" v-model="allCheck" />
                  <label for="checkTotal"><strong class="tcolor1 fw">취소</strong></label>
                </span>
              </th>
              <th scope="col">체험일</th>
              <th scope="col">상품</th>
              <th scope="col">회차</th>
              <th scope="col">인원</th>
              <th scope="col">상품금액</th>
              <th scope="col">할인금액</th>
              <!-- <th scope="col">결제금액</th> -->
            </tr>
          </thead>
          <tbody>
            <tr v-for="(rv, i) in detailList" :key="rv.pdRvNo">
              <td>
                <span v-if="rv.rvCancelYn === 'Y'">
                  취소
                  <br />
                  ({{ rv.rvCancelDtm }})
                </span>
                <span v-else-if="rv.cancelPossYn === 'Y'" class="checkbox">
                  <input type="checkbox" :id="'check' + rv.pdRvNo" :value="rv.pdRvNo" v-model="cancelPdRvNos" />
                  <label :for="'check' + rv.pdRvNo" class="blind">취소</label>
                </span>
              </td>
              <td v-if="i === 0" :rowspan="detailList.length">{{ rv.expVisitRvdtF }}</td>
              <td>
                {{ rv.pdNm }}
              </td>
              <td>{{ rv.scheSeqNo }}회차({{ rv.scheTm }})</td>
              <td class="tleft">
                <ul class="tlist1">
                  <li>
                    <strong>체험자</strong>
                    <span>{{ rv.experPcnt }}인</span>
                  </li>
                  <li v-if="rv.leaderPcnt > 0">
                    <strong>보호자</strong>
                    <span>{{ rv.leaderPcnt }}인</span>
                  </li>
                </ul>
              </td>
              <td class="tright">{{ _wonFormat(rv.rvAmt + rv.dcAmt) }}</td>
              <td class="tright">{{ _wonFormat(rv.dcAmt) }}</td>
              <!-- <td class="tright">{{ _wonFormat(rv.rvAmt) }}</td> -->
            </tr>
          </tbody>
        </table>
      </div>
      <div class="totalPriceBox mb50">
        <ul class="div3">
          <li>
            <strong>체험금액</strong>
            <span>
              <i class="fs_big tcolor1">{{ _priceFormat(totOriginPrice) }}</i>
              원
            </span>
          </li>
          <li class="price_icon1">
            <strong>할인금액</strong>
            <span>
              <i class="fs_big">{{ _priceFormat(totDcPrice) }}</i>
              원
            </span>
          </li>
          <!-- <li class="price_icon2">
            <strong>취소수수료</strong>
            <span>
              <i class="fs_big">0</i>
              원
            </span>
          </li> -->
          <li class="price_icon3">
            <strong>총결제금액</strong>
            <span>
              <i class="fs_big">{{ _priceFormat(totSalePrice) }}</i>
              원
            </span>
          </li>
        </ul>
      </div>
      <h4 class="stitle2 mb10 tleft">환불내역</h4>
      <div class="totalPriceBox mb20">
        <ul class="div3">
          <li>
            <strong>취소금액</strong>
            <span>
              <i class="fs_big tcolor1">{{ _priceFormat(refundInfo.saleAmt) }}</i>
              원
            </span>
          </li>
          <li class="price_icon1">
            <strong>
              할인공제액
              <div class="tooltip bgcolor">
                ?
                <span class="tooltip_text">입장료 할인 공제</span>
              </div>
            </strong>
            <span>
              <i class="fs_big">{{ _priceFormat(refundInfo.entncDeAmt) }}</i>
              원
            </span>
          </li>
          <li class="price_icon3">
            <strong>최종환불금액</strong>
            <span>
              <i class="fs_big">{{ _priceFormat(refundInfo.totRefuAmt) }}</i>
              원
            </span>
          </li>
        </ul>
      </div>

      <!--환불계좌 - 무통장입금인 경우 -->
      <div v-if="payInfo.payMethod == '04'">
        <h4 class="stitle2 mb10 tleft">환불계좌</h4>
        <div class="tb_wrap mb20">
          <table class="tb_basic">
            <caption></caption>
            <tbody>
              <tr>
                <th class="tbg">환불은행</th>
                <td class="tleft">
                  <select style="width: 160px" v-model="nobankRefuBankCd">
                    <option selected value="">은행선택</option>
                    <option v-for="item in refundBankList" :key="item.cd" :value="item.cd">{{ item.cdNm }}</option>
                  </select>
                </td>
                <th class="tbg">환불계좌번호</th>
                <td class="tleft">
                  <input type="text" style="width: 180px" v-model="nobankRefuAccNo" number maxlength="20" />
                </td>
                <th class="tbg">환불계좌주명</th>
                <td class="tleft">
                  <input type="text" style="width: 180px" v-model="nobankRefuAccNm" maxlength="100" />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <!--//환불계좌-->

      <div class="agree_wrap">
        <div class="agree_cont">
          <h5 class="stitle2 mb10 tleft">환불규정</h5>
          <ul class="colorBox mb10">
            <li>
              체험 시작 전까지
              <strong class="tcolor1">전액 환불</strong>
            </li>
            <li>
              체험 시작 후
              <strong class="tcolor2">환불 불가</strong>
            </li>
          </ul>
          <h5 class="stitle2 mb10 tleft">(예외)메카이브 Y.Class 환불규정</h5>
          <ul class="colorBox mb10">
            <li>
              체험 전날 23:59분
              <strong class="tcolor1">전액 환불</strong>
            </li>
            <li>
              체험 예정 날
              <strong class="tcolor2">환불 불가</strong>
            </li>
          </ul>
          <dl>
            <dt class="tcolor2">※다음의 사유로 체험이 불가능한 경우 환불이 가능합니다.(증빙제출은 체험일 포함 3일 이내)</dt>
            <dd>
              <ul class="tlist">
                <li>사촌 이내 친족의 사망</li>
                <li>법정전염병</li>
                <li>전시체험관 이용이 불가능한 질병 및 부상</li>
                <li>천재지변으로 교육관서의 이동제한 조치가 있거나 교통수단을 이용하는 것이 불가능한 경우</li>
              </ul>
            </dd>
          </dl>
        </div>
      </div>
      <p class="linebox checkbox mb50">
        <input type="checkbox" name="agree" id="agree01" v-model="confirmCheck" />
        <label for="agree01">
          환불규정동의
          <strong class="tcolor2">(필수)</strong>
        </label>
      </p>
      <div class="btn_area">
        <router-link class="btn btn_bg gray" :to="'/' + reservePgRoute + '/reservations'">예약목록</router-link>
        <a class="btn btn_bg color2" v-if="reserveInfo.rvProgSitu != '05'" @click="onCancelClick">예약취소</a>
      </div>
    </div>
    <!--// .container-->
  </div>
</template>

<script>
import { getReservation, calcCancelPrice, cancelReserve } from '@/api/api_reserve';

export default {
  data() {
    return {
      bundleRvNo: '',
      reserveInfo: {},
      detailList: [],
      payInfo: {},
      refundBankList: [],
      orderSheet: {},
      allCheck: false,
      cancelPdRvNos: [],
      nobankRefuBankCd: '',
      nobankRefuAccNo: '',
      nobankRefuAccNm: '',
      confirmCheck: false,
      refundInfo: { cancelSaleAmt: 0, entncDcAmt: 0, refundAmt: 0 },
      reservePgRoute: '',
    };
  },
  computed: {
    totOriginPrice() {
      return this.detailList.reduce((a, e) => a + e.rvAmt + e.dcAmt, 0);
    },
    totDcPrice() {
      return this.detailList.reduce((a, e) => a + e.dcAmt, 0);
    },
    totSalePrice() {
      return this.detailList.reduce((a, e) => a + e.rvAmt, 0);
    },
  },
  watch: {
    allCheck(to) {
      if (to) {
        this.cancelPdRvNos = this.detailList.filter((e) => e.cancelPossYn === 'Y').map((e) => e.pdRvNo);
      } else {
        this.cancelPdRvNos = [];
      }
    },
    cancelPdRvNos(to) {
      calcCancelPrice({ bundleRvNo: this.bundleRvNo, cancelPdRvNos: to }).then((e) => {
        if (e.success) {
          const { refundInfo } = e.response;
          this.refundInfo = refundInfo;
        }
      });
    },
  },
  async created() {
    this.initialLoad();
    this.bundleRvNo = this.$route.params.bundleRvNo;
    getReservation(this.bundleRvNo).then((data) => {
      if (data.success) {
        const { reserveInfo, detailList, payInfo, refundBankList } = data.response;
        this.reserveInfo = reserveInfo;
        this.detailList = detailList;
        this.payInfo = payInfo || {};
        this.refundBankList = refundBankList;
        this.reservePgRoute = reserveInfo.groupPersDiv === '01' ? 'grp' : 'ind';
      }
    });
  },
  mounted() {},
  destroyed() {
    if (window.event_msg) {
      window.event_msg = undefined;
    }
  },
  methods: {
    async initialLoad() {
      await this.$loadScript('https://api.purmee.kr/static/js/client.js').then((e) => {
        e.classList.add('payform'); //class="payform" 고정 값입니다.
      });
    },
    async onCancelClick() {
      let bankParam = {};

      if (this.cancelPdRvNos.length < 1) {
        alert('선택된 예약내역이 없습니다.');
        return false;
      }

      if (this.payInfo.payMethod === '04') {
        if (!this.nobankRefuBankCd) {
          alert('환불은행을 선택해 주세요.');
          return false;
        }

        if (!this.nobankRefuAccNo) {
          alert('환불계좌번호를 입력해 주세요.');
          return false;
        }

        if (!this.nobankRefuAccNm) {
          alert('환불계좌주명을 입력해 주세요.');
          return false;
        }

        bankParam = {
          payMethod: '04',
          nobankRefuBankCd: this.nobankRefuBankCd,
          nobankRefuAccNo: this.nobankRefuAccNo,
          nobankRefuAccNm: this.nobankRefuAccNm,
        };
      }

      if (!this.confirmCheck) {
        alert('환불규정동의를 해주세요');
        return false;
      }

      const error = this.cancelPdRvNos.some((e) => {
        const detail = this.detailList.find((d) => d.pdRvNo === e);
        if (detail?.cancelPossYn !== 'Y') {
          alert('취소가 불가능한 예약입니다.');
          return true;
        }
      });
      if (error) return;

      customConfirm('예약을 취소하시겠습니까?', async (confirm) => {
        if (confirm) {
          try {
            //푸르미
            if (this.payInfo.payMethod === '09') {
              this.cancelPurmee();
            } else {
              const result = await cancelReserve({ bundleRvNo: this.bundleRvNo, cancelPdRvNos: this.cancelPdRvNos, ...bankParam });
              if (result.success) {
                alert('취소 되었습니다.');
                this.$router.push('/' + this.reservePgRoute + '/reservations');
                //this.$router.push('/reservations/' + this.bundleRvNo);
              }
            }
          } catch (e) {
            console.error(e);
            alert('오류가 발생하였습니다.');
          }
        }
      });
    },
    cancelPurmee() {
      if (typeof window.event_msg !== 'function') {
        window.event_msg = (data) => {
          if (data.result.code === '00') {
            this.cancelPurmeeReserve(data);
          } else {
            alert('취소에 실패했습니다. 다시 시도해주시기 바랍니다.');
            return false;
          }
        };
      }

      PAYMENT.refund({
        payKey: 'pk_a473-14721f-d30-4aeea',
        trackId: this.payInfo.orderNo,
        originTrackId: '',
        originTrnDate: '',
        originTrnNo: this.payInfo.dealNo,
        amount: this.refundInfo.totRefuAmt,
        description: '설명',
        eventFnc: 'event_msg',
        udf1: 'udf1',
        udf2: 'udf2',
        udf3: 'udf3',
        udf4: 'udf4',
        debug: true,
      });
    },
    async cancelPurmeeReserve(data) {
      const prumiParam = JSON.stringify(data);
      const result = await cancelReserve({
        bundleRvNo: this.bundleRvNo,
        payMethod: this.payInfo.payMethod,
        cancelPdRvNos: this.cancelPdRvNos,
        prumiParam: prumiParam,
      });
      if (result.success) {
        alert('취소 되었습니다.');
        this.$router.push('/' + this.reservePgRoute + '/reservations');
        //this.$router.push('/reservations/' + this.bundleRvNo);
      }
    },
  },
};
</script>

<style></style>
